import React from 'react';

const ClienteContext = React.createContext({
  cliente: null,
  setCliente: () => {},
  setComisiones: () => {},
});

export default ClienteContext;